import React, { useEffect, useState, useContext, useRef } from 'react';
import { SettingsState } from '../../../organisms/SelectSettings';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../../App';
import { useModal } from '../../../../function/useModal';
import { NAME_DEV_SET, GetNameDevSetList } from '../../../../function/NameDevSetModel';
import { NAME_ITEM_SET, GetNameItemSetList } from '../../../../function/NameItemSetModel';

import { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';
import { ErrorCode } from '../../../../ErrorCode';

import {
  ApiResponseCode,
  CheckConanairManagementFlg,
  CheckInputData,
  CONNAIR_SET,
  CreateConanairManagementModel,
  DeleteConanAirManagement,
  GetConanairManagement,
  PutConanairManagement,
  ColSetLogModel,
} from './ConanairManagement';
import ConanairManagementFooter from './ConanairManagementFooter';
import ConanairManagementGridRow from './ConanairManagementGridRow';
import { TableUseStyle, ConanairManagementStyle } from './ConanairManagementStyle';

import ConanairManagementGridRowNewDialog, {
  ConanairManagementGridRowNewDialogResponse,
} from './ConanairManagementGridRowNewDialog';
import { Update } from '@material-ui/icons';

type ConanairManagementProps = {
  editData: SettingsState;
};

/**
 * Conanair管理画面メインページ
 * @param props
 */
const ConanairManagementPage: React.FC<ConanairManagementProps> = (props: ConanairManagementProps) => {
  const { t } = useTranslation();
  const pageStyle = ConanairManagementStyle();
  const { login } = useContext(AppContext);

  // 設定画面リスト
  const [conanList, setConanList] = useState<CONNAIR_SET[]>([]);
  const [colSetlogItemList, SetColSetlogItemList] = useState<ColSetLogModel[]>([]);
  const [nameDevSet, setNameDevSet] = useState<NAME_DEV_SET[]>([]);
  const [nameItemSet, setNameItemSet] = useState<NAME_ITEM_SET[]>([]);
  const [devNoComboList, setDevNoComboList] = useState<ComboBoxItemType[]>([]);
  const [nameItemComboList, setNameItemComboList] = useState<ComboBoxItemType[]>([]);

  const [selectIdx, setSelectIdx] = useState<number>(-1);
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const [dlgmsg, setDlgmsg] = useState<string>('');

  // 新規登録ダイアログ
  const [flgNewRow, newRowDlg] = useModal<ConanairManagementGridRowNewDialogResponse>();

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('ConanairManagementPage.はい', 'はい')}
      cancel={t('ConanairManagementPage.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  /**
   * 初期表示
   */
  useEffect(() => {
    /** 行データの呼び出し */
    updateData();
  }, []);

  useEffect(() => {
    props.editData.SaveFunction = saveAction2;
    props.editData.IsUpdate = false;
  }, [props.editData.CancelCondition]);

  /**
   * 行データの呼び出し
   */
  const updateData = () => {
    //V_CONANAIR_MANAGEMENT_ITEMをとってくる
    //SetDevListに放り込む
    //NAME_DEV_SETの取得
    setButtonEnable(false);
    let devSet: NAME_DEV_SET[] = [];
    let itemSet: NAME_ITEM_SET[] = [];
    let devComList: ComboBoxItemType[] = [];
    let nameItemComList: ComboBoxItemType[] = [];
    let conanairItemList: CONNAIR_SET[] = [];
    let ColSetLogModelList: ColSetLogModel[] = [];

    GetNameDevSetList()
      .then((res) => {
        devSet = res;
        return GetNameItemSetList();
      })
      .then((res) => {
        itemSet = res;
        return GetConanairManagement();
      })
      .then((res) => {
        conanairItemList = res.ConanairSetList;
        ColSetLogModelList = res.ColSetLogList;

        //収集時刻の読込
        conanairItemList.forEach((r) => {
          let colItem = ColSetLogModelList.find((res) => res.PlcNo === r.PLC_NO);
          if (colItem !== undefined) {
            r.logStart = colItem.LogStart;
          }
        });
        console.debug(['test_ConanairSetList', res.ConanairSetList, ColSetLogModelList]);
        //機器番号リストフィルター
        devSet = devSet.filter((row) => {
          if (conanairItemList.findIndex((row2) => row2.DEV_INDEX === row.DEV_INDEX) !== -1) {
            return true;
          }
          if (row.EST === 1) {
            return true;
          }
          return false;
        });

        devSet.forEach((r) => {
          devComList.push({ index: r.DEV_INDEX, name: r.DEV_NO });
        });
        itemSet
          .filter((r) => r.EST === 1 && (r.ITM_NAME_NO == 1 || r.ITM_NAME_NO == 2 || r.ITM_NAME_NO == 18))
          .forEach((row) => {
            //取付箇所のコンボボックス作成
            nameItemComList.push({ index: row.ITM_NAME_NO, name: row.ITM_NAME });
          });

        // console.debug(["test_ConanairSetList",res.ConanairSetList])
        conanairItemList.forEach((r) => {
          let temp = devSet.find((row) => {
            return row.DEV_INDEX === r.DEV_INDEX;
          });
          if (temp !== undefined) {
            r.devName = temp.DEV_NAME;
          }
        });
        setSelectIdx(-1);
        setNameDevSet(devSet);
        setNameItemSet(itemSet);
        setDevNoComboList(devComList);
        setNameItemComboList(nameItemComList);
        setConanList(conanairItemList);
        SetColSetlogItemList(ColSetLogModelList);
        // console.debug(["test_conanairItemList",conanairItemList])
      })
      .catch((r) => {
        setDlgmsg(t('ConanairManagementPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['saveAction error', r]);
      })
      .finally(() => {
        setButtonEnable(true);
      });
    props.editData.IsUpdate = false;
  };

  /**　新規登録ダイアログ */
  const newAction = () => {
    if (conanList.length >= 100) {
      setDlgmsg(
        t('ConanairManagementPage.登録できるコナンエアIDは100までです', '登録できるコナンエアIDは100までです。')
      );
      actMsgDlg.open();
      return;
    }
    /** 編集途中の場合確認 */
    if (CheckConanairManagementFlg(conanList)) {
      setDlgmsg(
        t(
          'ConanairManagementPage.編集中の内容が破棄されますが_よろしいですか',
          '編集中の内容が破棄されますが \nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          console.debug('handleNewDialogShow()');
          newRowDlg
            .open()
            .apply(() => {
              // API実行成功後のコールバック
              console.debug('apply()');
              updateData();
            })
            .cancel(() => {
              console.debug('cancel()');
              updateData();
            });
        })
        .cancel(() => {
          console.debug(t('ConanairManagementPage.キャンセル', 'キャンセル'));
        });
    } else {
      console.debug('handleNewDialogShow()');
      newRowDlg
        .open()
        .apply(() => {
          // API実行成功後のコールバック
          console.debug('apply()');
          updateData();
        })
        .cancel(() => {
          console.debug('cancel()');
          updateData();
        });
    }
  };

  /**
   * 保存アクション
   */
  const saveAction = () => {
    if (CheckConanairManagementFlg(conanList)) {
      let message = CheckInputData(conanList, nameDevSet, t);
      if (message.length !== 0) {
        setDlgmsg(message.join('\n'));
        actMsgDlg.open();
        return;
      }
      setDlgmsg(
        t('ConanairManagementPage.編集内容を保存します_よろしいですか', '編集内容を保存します。\nよろしいですか?')
      );
      actCfmDlg
        .open()
        .apply((_) => {
          let editModel = CreateConanairManagementModel();
          let editList = conanList.filter((r) => r.isEdit === true);
          editModel.ConanairSetList = editList;
          editModel.ColSetLogList = colSetlogItemList;
          setButtonEnable(false);
          PutConanairManagement(editModel)
            .then((r) => {
              if (r.ErrorCode === ErrorCode.ERR_CODE_NONE) {
                setDlgmsg(t('ConanairManagementPage.保存が正常に終了しました', '保存が正常に終了しました'));
                actMsgDlg.open();
                updateData();
                console.debug('saveAction ok');
              } else if (r.ErrorCode === ErrorCode.ERR_CODE_CONAN_DEVINDEX_IOT_REGISTERED) {
                setDlgmsg(
                  t(
                    'ConanairManagementPage.TMBEE-BOX管理画面側で使用中の機器番号と重複したため中断しました\n保存する場合はデータ収集設定画面にて対象機器番号の計測種別振動の実行フラグを外すことが必要です',
                    'TMBEE-BOX管理画面側で使用中の「機器番号」と重複したため中断しました\n保存する場合は、データ収集設定画面にて対象機器番号の計測種別『振動』の実行フラグを外すことが必要です'
                  )
                );
                actMsgDlg.open();
              } else if (r.ErrorCode === ErrorCode.ERR_CODE_CONAN_CONANAIRSET_NODATA) {
                setDlgmsg(
                  t(
                    'ConanairManagementPage.CONANAIR_SETテーブルに変更対象が登録されていないため中断しました',
                    'CONANAIR_SETテーブルに変更対象が登録されていないため中断しました'
                  )
                );
                actMsgDlg.open();
              } else if (r.ErrorCode === ErrorCode.ERR_CODE_CONAN_COLSET_NODATA) {
                setDlgmsg(
                  t(
                    'ConanairManagementPage.COL_SETテーブルに変更対象が登録されていないため中断しました',
                    'COL_SETテーブルに変更対象が登録されていないため中断しました'
                  )
                );
                actMsgDlg.open();
              } else if (r.ErrorCode === ErrorCode.ERR_CODE_IPADR_INCORRECT) {
                setDlgmsg(
                  t(
                    'ConanairManagementPage.機器番号が重複しているため中断しました',
                    '機器番号が重複しているため中断しました'
                  )
                );
                actMsgDlg.open();
              }
            })
            .catch((r) => {
              setDlgmsg(t('ConanairManagementPage.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
              actMsgDlg.open();
              console.error(['saveAction error', r]);
            })
            .finally(() => {
              setButtonEnable(true);
            });
        })
        .cancel(() => {
          console.debug(t('ConanairManagementPage.キャンセル', 'キャンセル'));
        });
    }
  };

  /**
   * タブ切替時に動作
   * @param param
   * @returns
   */
  const saveAction2 = (param: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const sp = param as { cList: CONNAIR_SET[]; nList: NAME_DEV_SET[]; csList: ColSetLogModel[] };
      let message = CheckInputData(sp.cList, sp.nList, t);
      console.debug(['--mssage1--', message, sp, param]);
      if (message.length !== 0) {
        console.debug(['--mssage2--', message]);
        setDlgmsg(message.join('\n'));
        actMsgDlg.open();
        reject('data error');
        return;
      }
      let editModel = CreateConanairManagementModel();
      let editList = sp.cList.filter((r) => r.isEdit === true);
      editModel.ConanairSetList = editList;
      editModel.ColSetLogList = sp.csList;
      setButtonEnable(false);

      PutConanairManagement(editModel)
        .then((r) => {
          props.editData.IsUpdate = false;
          console.debug('saveAction ok');
          resolve('done');
        })
        .catch((r) => {
          setDlgmsg(t('ConanairManagementPage.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
          actMsgDlg.open();
          console.error(['saveAction error', r]);
          reject('data error');
        })
        .finally(() => {
          setButtonEnable(true);
        });
    });
  };

  /**
   * 中止アクション
   */
  const cancelAction = () => {
    if (CheckConanairManagementFlg(conanList)) {
      setDlgmsg(
        t(
          'ConanairManagementPage.保存していないデータを破棄します_よろしいですか',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          updateData();
          props.editData.UpdateCancel();
          props.editData.IsUpdate = false;
          console.debug(t('ConanairManagementPage.実行', '実行'));
        })
        .cancel(() => {
          console.debug(t('ConanairManagementPage.キャンセル', 'キャンセル'));
        });
    }
  };
  /**
   * 　削除アクション
   */
  const deleteAction = () => {
    if (selectIdx >= 0) {
      setButtonEnable(false);
      if (CheckConanairManagementFlg(conanList)) {
        setDlgmsg(`CNA_ID:${conanList[selectIdx - 1].CNA_ID}
        ${t(
          'ConanairManagementPage.コナンエアの登録を削除しますか_編集中の内容は破棄されます',
          'コナンエアの登録を削除しますか？(編集中の内容は破棄されます)'
        )}`);
      } else {
        setDlgmsg(`CNA_ID:${conanList[selectIdx - 1].CNA_ID}
        ${t('ConanairManagementPage.コナンエアの登録を削除しますか', 'コナンエアの登録を削除しますか？')}`);
      }

      actCfmDlg
        .open()
        .apply((_) => {
          DeleteConanAirManagement(conanList[selectIdx - 1] ? conanList[selectIdx - 1].CNA_ID : '')
            .then((status: number) => {
              console.debug(['status', status]);
              if (status == ApiResponseCode.SUCCESS) {
                /** 削除登録要求をレコード追加 非同期待ち */
                updateData();
                // setButtonEnable(true); updateDataの中で行っているので不要
              }
            })
            .catch((r) => {
              setDlgmsg(t('ConanairManagementPage.削除中にエラーが発生しました', '削除中にエラーが発生しました'));
              actMsgDlg.open();
              console.error(['saveAction error', r]);
              setButtonEnable(true);
            });
        })
        .cancel(() => {
          console.debug(t('ConanairManagementPage.キャンセル', 'キャンセル'));
          setButtonEnable(true);
        });
    }
  };

  /**
   * データ変更アクション
   * @param item
   */
  const itemUpdateAction = (item: CONNAIR_SET) => {
    console.debug(['itemUpdateAction', item]);
    item.isEdit = true;
    props.editData.IsUpdate = true;
    /** 機器名称 */
    let temp = nameDevSet.find((row) => {
      return row.DEV_INDEX === item.DEV_INDEX;
    });
    if (temp !== undefined) {
      item.devName = temp.DEV_NAME;
    }
    /** コナンエアID */
    const idx = conanList.findIndex((itm) => itm.CNA_ID === item.CNA_ID);

    /**収集時刻 */
    if (login.IsIoT === true) {
      colSetlogItemList.forEach((r) => {
        r.LogStart = r.PlcNo === item.PLC_NO ? item.logStart : r.LogStart;
      });
    }

    if (idx >= 0) {
      /** 画面更新のためArrayの再生成 */
      const temp = conanList.concat();
      temp[idx] = item;
      setConanList(temp);
    }
    props.editData.Target = { cList: conanList, nList: nameDevSet, csList: colSetlogItemList };
  };

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 5 }}>
        <Grid item xs={12}>
          <TableContainer component={Paper} className={pageStyle.tableContainer}>
            <Table stickyHeader aria-label="featureParamater">
              <TableHead>
                <TableRow>
                  <TableCell className={pageStyle.fixHeader} width={50}>
                    No
                  </TableCell>
                  <TableCell className={pageStyle.fixHeader} width={80}>
                    {t('ConanairManagementPage.機器番号', '機器番号')}
                  </TableCell>
                  <TableCell className={pageStyle.fixHeader} width={120}>
                    {t('ConanairManagementPage.機器名称', '機器名称')}
                  </TableCell>
                  <TableCell className={pageStyle.fixHeader} width={120}>
                    {t('ConanairManagementPage.取付箇所', '取付箇所')}
                  </TableCell>
                  <TableCell className={pageStyle.fixHeader} width={120}>
                    {t('ConanairManagementPage.コナンエアID', 'コナンエアID')}
                  </TableCell>
                  {login.IsIoT === true ? (
                    <TableCell className={pageStyle.fixHeader} width={60}>
                      {t('ConanairManagementPage.収集時刻', '収集時刻')}
                    </TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {conanList.map((item, idx) => {
                  return (
                    <ConanairManagementGridRow
                      rowno={idx + 1}
                      selectIdx={selectIdx}
                      conanItem={item}
                      updateItem={itemUpdateAction}
                      devCombList={devNoComboList}
                      setSelectIdx={setSelectIdx}
                      nameItemCombList={nameItemComboList}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <ConanairManagementFooter
            onClickNewButton={newAction}
            onClickSaveButton={saveAction}
            onClickCancelButton={cancelAction}
            onClickDelButton={deleteAction}
            buttonEnable={buttonEnable}
          ></ConanairManagementFooter>
        </Grid>
      </Grid>
      {/* コナンエアID新規登録 */}
      {flgNewRow ? (
        <ConanairManagementGridRowNewDialog
          dialog={newRowDlg}
          devNoComBox={devNoComboList}
          nameItemComBox={nameItemComboList}
        />
      ) : null}
      {cfmdlg}
      {msgdlg}
    </>
  );
};

export default ConanairManagementPage;
